module.exports = __webpack_public_path__ + "static/media/cornerradius.e5758777.svg";